import Vue from 'vue'
import App from './App.vue' 
import router from './router'
import store from './store/index.js'
import vuetify from './plugins/vuetify';
import VueTour from 'vue-tour'
import OtpInput from "@bachdgvn/vue-otp-input" 

require('vue-tour/dist/vue-tour.css')
Vue.component("v-otp-input", OtpInput);
Vue.use(VueTour)

Vue.config.productionTip = false

import Axios from 'axios'
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAu2Jn1_i1AIfTkiS339kStNrWMZUD08UE",
    libraries: "places" // necessary for places input
  }
});

// Axios.defaults.baseURL = "http://localhost:3000"
Axios.defaults.baseURL = "https://proguardpeercover.herokuapp.com/"
// Axios.defaults.baseURL = "https://www.proguard.peercover.com.ng/"

Vue.prototype.$http = Axios;
const token = localStorage.getItem('token');
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

new Vue({
  router,
  store,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')
